import { useEffect, useState } from "react";
import { TipList, type PublicTip } from "./TipList";
export const TIP_TAGS = [
	"앞이 잘 보여요",
	"가림 있어요",
	"단차 좋아요",
	"무릎 좁아요",
	"소리 좋아요",
	"소리 울려요",
	"출입 편해요",
	"계단 많아요",
];
export function VenueTips({ venueId }: { venueId: string }) {
	const [tag, setTag] = useState(""),
		[floor, setFloor] = useState(""),
		[q, setQ] = useState(""),
		[tips, setTips] = useState<PublicTip[] | null>(null),
		[error, setError] = useState(""),
		[retry, setRetry] = useState(0),
		[cursor, setCursor] = useState<string | null>(null);
	useEffect(() => {
		const controller = new AbortController();
		setTips(null);
		setError("");
		fetch(
			`/api/venues/${venueId}/tips?${new URLSearchParams({ tag, floor, q })}`,
			{ signal: controller.signal },
		)
			.then(async (r) => {
				if (!r.ok) throw new Error();
				const d = (await r.json()) as {
					tips: PublicTip[];
					nextCursor: string | null;
				};
				setTips(d.tips);
				setCursor(d.nextCursor);
			})
			.catch(() => {
				if (!controller.signal.aborted)
					setError("한 줄을 불러오지 못했어요. 연결을 확인해 주세요.");
			});
		return () => controller.abort();
	}, [venueId, tag, floor, q, retry]);
	async function more() {
		try {
			const r = await fetch(
				`/api/venues/${venueId}/tips?${new URLSearchParams({ tag, floor, q, cursor: cursor ?? "" })}`,
			);
			if (!r.ok) throw new Error();
			const d = (await r.json()) as {
				tips: PublicTip[];
				nextCursor: string | null;
			};
			setTips((v) => [...(v ?? []), ...d.tips]);
			setCursor(d.nextCursor);
		} catch {
			setError("다음 한 줄을 불러오지 못했어요.");
		}
	}
	return (
		<section className="stack">
			<h2>앉아본 사람 한 줄</h2>
			<label className="field">
				검색어
				<input
					className="input"
					value={q}
					onChange={(e) => setQ(e.target.value)}
					placeholder="예: 난간 가림"
				/>
			</label>
			<div className="inline">
				<label className="field">
					태그
					<select
						className="input"
						value={tag}
						onChange={(e) => setTag(e.target.value)}
					>
						<option value="">모두 보기</option>
						{TIP_TAGS.map((t) => (
							<option key={t}>{t}</option>
						))}
					</select>
				</label>
				<label className="field">
					층
					<select
						className="input"
						value={floor}
						onChange={(e) => setFloor(e.target.value)}
					>
						<option value="">모두 보기</option>
						{["1층", "2층", "3층"].map((f) => (
							<option key={f}>{f}</option>
						))}
					</select>
				</label>
			</div>
			{error ? (
				<p role="alert">
					{error}
					<button type="button" onClick={() => setRetry(retry + 1)}>
						다시 불러오기
					</button>
				</p>
			) : tips ? (
				<>
					<TipList tips={tips} />
					{!tips.length && q ? (
						<button className="button" type="button" onClick={() => setQ("")}>
							검색어 지우기
						</button>
					) : null}
					{cursor ? (
						<button
							className="button"
							type="button"
							onClick={() => void more()}
						>
							다음 한 줄 보기
						</button>
					) : null}
				</>
			) : (
				<p role="status">한 줄을 불러오고 있어요.</p>
			)}
		</section>
	);
}
